const REGISTRATION_NUMBER_REGEX = /[^A-Z0-9]/g;
const REGISTRATION_NUMBER_MAX_LENGTH = 8;
export const sanitizeRegistrationNumber = (registrationNumber) => {
    return registrationNumber
        .toUpperCase()
        .replace(REGISTRATION_NUMBER_REGEX, '')
        .slice(0, REGISTRATION_NUMBER_MAX_LENGTH);
};
